/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IGame } from "../interfaces/intefaces";
import { useTranslation } from "../hooks/hooks";
import { useAtom } from "jotai";
import { currentGameAtom, gamesUserFavoritesAtom, userIsLoggedInAtom } from "../state/games";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";
import { AddFavoriteIcon, AddedFavoriteIcon } from "./Icons";
import Icon from "./Icon";
import { Alert, Button, Snackbar } from "@mui/material";
import _ from "lodash";
import axios from "axios";
import { UserFavoritesEndpointUrl } from "../config/consts";
import { getCookie } from "../helpers/helpers";

interface IProps {
    game: IGame;
}
const Game = ({ game }: IProps) => {
    const { _e } = useTranslation();
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [, setCurrentGame] = useAtom(currentGameAtom);
    const [favorite, setFavorite] = useState(false);
    const [gamesUserFavorites, dispatch] = useAtom(gamesUserFavoritesAtom);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const addToFavorites = (game: IGame, userIsLoggedIn: boolean) => {
        if (!userIsLoggedIn) {
            const el = document.getElementById("login-button");
            if (el !== null) {
                el.click();
            }
            return false;
        }
        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: UserFavoritesEndpointUrl,
            params: { gameid: game.id },
            withCredentials: true,
            headers: {
                "X-XSRF-TOKEN": getCookie("XSRF-TOKEN"),
            },
        };

        axios
            .request(config)
            .then(response => {
                if (response.data.status === 200) {
                    setFavorite(true);
                    dispatch({ type: "add", payload: { count: 1, games: [game] } });
                } else {
                    setError("Unable to add game to favorites");
                }
            })
            .catch(error => {
                setError("Unable to add game to favorites");
                console.log(error);
            });
        return true;
    };

    const removeFromFavorites = (game: IGame, userIsLoggedIn: boolean) => {
        if (!userIsLoggedIn) {
            const el = document.getElementById("login-button");
            if (el !== null) {
                el.click();
            }
            return false;
        }
        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: UserFavoritesEndpointUrl,
            params: { gameid: game.id },
            withCredentials: true,
            headers: {
                "X-XSRF-TOKEN": getCookie("XSRF-TOKEN"),
            },
        };

        axios
            .request(config)
            .then(response => {
                setFavorite(false);
                if (response.data.status === 200) {
                    setFavorite(false);
                    dispatch({ type: "remove", payload: { count: 1, games: [game] } });
                } else {
                    setError("Unable to remove game to favorites");
                }
            })
            .catch(error => {
                setError("Unable to remove game to favorites");
                console.log(error);
            });
        return true;
    };

    useEffect(() => {
        setFavorite(_.find(gamesUserFavorites?.games, { id: game.id }) !== undefined);
    }, [gamesUserFavorites]);

    const handleGameClick = (
        game: IGame,
        userIsLoggedIn: boolean,
        loginRequired: boolean,
        for_fun_supported: number,
    ) => {
        if (!userIsLoggedIn && loginRequired) {
            const el = document.getElementById("login-button");
            if (el !== null) {
                el.click();
            }
            return false;
        }
        setCurrentGame(game);
        const url = new URL(game.url);
        navigate(
            `${routes.pages.game}?${url.searchParams.toString()}&plat_user=${game.pu}&for_fun=${for_fun_supported}`,
        );
        return true;
    };

    return (
        <>
            <div key={game.id} className="game">
                <div>
                    <div className="image-wrap">
                        <img src={`${game.gmi[0]}/gamelogo`} alt={game.pt} />
                    </div>
                    <div className="game-inner">
                        <span className="provider-title">{game.gpn}</span>
                        {favorite ? (
                            <Button
                                className="favorite-button"
                                onClick={() => removeFromFavorites(game, userIsLoggedIn)}
                            >
                                <Icon cssclass="favorite-icon" icon={AddedFavoriteIcon} />
                            </Button>
                        ) : (
                            <Button
                                className="favorite-button"
                                onClick={() => addToFavorites(game, userIsLoggedIn)}
                            >
                                <Icon cssclass="favorite-icon" icon={AddFavoriteIcon} />
                            </Button>
                        )}
                        <div className="btn-wrap">
                            <Button
                                variant="outlined"
                                onClick={() => handleGameClick(game, userIsLoggedIn, true, 0)}
                            >
                                {_e("PLAY")}
                            </Button>
                            {game.ffs == 1 && (
                                <Button
                                    variant="text"
                                    onClick={() => handleGameClick(game, userIsLoggedIn, false, 1)}
                                >
                                    {_e("PLAY FOR FUN")}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
                <span className="title" dangerouslySetInnerHTML={{ __html: game.pt }} />
            </div>
            {error !== "" && (
                <Snackbar
                    open={true}
                    onClose={() => setError("")}
                    autoHideDuration={2000}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                    <Alert severity="error" sx={{ width: "100%" }}>
                        {error}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
};

export default Game;
